import React from 'react';
import PropTypes from 'prop-types';
import Back from '../../../assets/icon_back.svg';

import './Header.scss';

const Header = ({ label, className = '', goBack }) => {
  return (
    <div
      className={'header-container ' + className}
      onClick={goBack ? () => goBack() : () => window.history.go(-1)}
    >
      <img alt={Back} className="back-button-header" src={Back} />{' '}
      <span className="register-salon-label">{label}</span>
    </div>
  );
};

Header.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
};

export default Header;
